import React from 'react';
import numeral from 'numeral';
export default class MoneyFormat extends React.Component {
    render() {
        //<FormattedNumber value={this.props.value} style="currency" currency="USD" minimumFractionDigits="2" />
        return (
        <span>{this.props.currency} {numeral(this.props.value).format(`0,0.00`)}</span>
        );        
    }
}



// WEBPACK FOOTER //
// ./app/components/MoneyFormat.js